import api from './api';
import { GenericCRUDService } from './genericCRUD';
import { EntityDefinition } from '@/types/crud';

// Generic CRUD service for ABAC entities - REDUNDANT (using GenericCRUDService now)
// REMOVED: xxxx_ABACService and xxxx_abacCustomAttributeService - replaced by GenericCRUDService

// Wrapper services that implement GenericCRUDService interface
export class ABACGenericCRUDService extends GenericCRUDService {
  constructor(entity: EntityDefinition) {
    super(entity);
  }
}

// Create instances for ABAC entities
export const abacActionGenericService = new ABACGenericCRUDService({
  name: 'abac_actions',
  apiEndpoint: '/generic/abac_actions',
  displayName: 'Action',
  fields: [],
  tableColumns: []
});

export const abacCustomAttributeGenericService = new ABACGenericCRUDService({
  name: 'abac_custom_attributes',
  apiEndpoint: '/generic/abac_custom_attributes', 
  displayName: 'Custom Attribute',
  fields: [],
  tableColumns: []
});

// Specialized service for User Attributes that automatically filters by attribute_type
export const abacUserAttributeService = {
  async getAll(params: any = {}) {
    const response = await api.get('/generic/abac_custom_attributes', { 
      params: { ...params, attribute_type: 'USER' } 
    });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get(`/generic/abac_custom_attributes/${id}`);
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/generic/abac_custom_attributes', { ...data, attribute_type: 'USER' });
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.put(`/generic/abac_custom_attributes/${id}`, { ...data, attribute_type: 'USER' });
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/generic/abac_custom_attributes/${id}`);
    return response.data;
  },

  async toggleStatus(id: string, isActive: boolean) {
    const response = await api.patch(`/generic/abac_custom_attributes/${id}/status`, { is_active: isActive });
    return response.data;
  }
};

// Specialized service for Resource Attributes that automatically filters by attribute_type
export const abacResourceAttributeService = {
  async getAll(params: any = {}) {
    const response = await api.get('/generic/abac_custom_attributes', { 
      params: { ...params, attribute_type: 'RESOURCE' } 
    });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get(`/generic/abac_custom_attributes/${id}`);
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/generic/abac_custom_attributes', { ...data, attribute_type: 'RESOURCE' });
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.put(`/generic/abac_custom_attributes/${id}`, { ...data, attribute_type: 'RESOURCE' });
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/generic/abac_custom_attributes/${id}`);
    return response.data;
  },

  async toggleStatus(id: string, isActive: boolean) {
    const response = await api.patch(`/generic/abac_custom_attributes/${id}/status`, { is_active: isActive });
    return response.data;
  }
};

// Specialized service for Environment Attributes that automatically filters by attribute_type
export const abacEnvironmentAttributeService = {
  async getAll(params: any = {}) {
    const response = await api.get('/generic/abac_custom_attributes', { 
      params: { ...params, attribute_type: 'ENVIRONMENT' } 
    });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get(`/generic/abac_custom_attributes/${id}`);
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/generic/abac_custom_attributes', { ...data, attribute_type: 'ENVIRONMENT' });
    return response.data;
  },

  async update(id: string, data: any) {
        const response = await api.put(`/generic/abac_custom_attributes/${id}`, { ...data, attribute_type: 'ENVIRONMENT' });
        return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/generic/abac_custom_attributes/${id}`);
    return response.data;
  },

  async toggleStatus(id: string, isActive: boolean) {
    const response = await api.patch(`/generic/abac_custom_attributes/${id}/status`, { is_active: isActive });
    return response.data;
  }
};

// Service for Actions using the dedicated abac_actions table - REDUNDANT (using GenericCRUDService now)
// REMOVED: xxxx_abacActionService - replaced by GenericCRUDService

// Specialized services for user and resource attribute management
export const abacUserService = {
  async getAll(params: any = {}) {
    const response = await api.get('/abac/users', { params });
    return response.data;
  },

  async assignAttributeValues(data: any) {
    const response = await api.post('/abac/attribute-values', data);
    return response.data;
  },

  async deleteAttributeValue(valueId: string) {
    const response = await api.delete(`/abac/attribute-values/${valueId}`);
    return response.data;
  }
};

export const abacResourceService = {
  async getAll(params: any = {}) {
    const response = await api.get('/abac/resources', { params });
    return response.data;
  },

  async assignAttributeValues(data: any) {
    const response = await api.post('/abac/attribute-values', data);
    return response.data;
  },

  async deleteAttributeValue(valueId: string) {
    const response = await api.delete(`/abac/attribute-values/${valueId}`);
    return response.data;
  }
};

// ABAC Policy Management Service
export const abacPolicyService = {
  async getAll(params: any = {}) {
    const response = await api.get('/abac-policy/policies', { params });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get(`/abac-policy/policies/${id}`);
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/abac-policy/policies', data);
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.put(`/abac-policy/policies/${id}`, data);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/abac-policy/policies/${id}`);
    return response.data;
  },

  async testPolicy(testData: any) {
    const response = await api.post('/abac-policy/test', testData);
    return response.data;
  },

  // Get custom attributes for policy creation
  async getCustomAttributes() {
    // Calling getCustomAttributes
    const response = await api.get('/abac/custom-attributes');
        return response.data;
  },

  // Get actions for policy creation
  async getActions() {
    // Calling getActions
    const response = await api.get('/generic/abac_actions');
        return response.data;
  }
};
